import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  time: number,
 *  answeredCount: number
 * }} DealerAnswerTimeStatisticsReducer
 */
/** @type {DealerAnswerTimeStatisticsReducer} */
const initialState = {
  answeredCount: null,
  time: null,
};

/**
 * @param {DealerAnswerTimeStatisticsReducer} state
 * @param {import('modules/statistics/types').FetchAnswerTimeSuccessAction} action
 * @returns {DealerAnswerTimeStatisticsReducer}
 */
const updateAllData = (state, { payload }) => {
  const { responseTime: time = null, id: answeredCount = null } = payload.content?.[0] ?? {};
  return {
    ...state,
    time,
    answeredCount,
  };
};

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_ANSWER_TIME_SUCCESS]: updateAllData,
});
